import { Component, OnInit } from '@angular/core';
import { FileStatsObject } from '@it2go/types';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TableModule } from '@openng/optimus-ui/table';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { LocalDatePipe } from '../../../../../shared/pipes/local-date.pipe';

@Component({
    selector: 'app-file-stats-dialog',
    templateUrl: './file-stats-dialog.component.html',
    styleUrl: './file-stats-dialog.component.scss',
    imports: [
        ActionButtonsComponent,
        LocalDatePipe,
        PrimeTemplate,
        TableModule,
        TranslatePipe,
    ],
})
export class FileStatsDialogComponent extends BaseDialogComponent implements OnInit {
    
    stats!: FileStatsObject[];

    public ngOnInit(): void {
        this.stats = this.dialogConfig.data.stats;
    }
}
